import RecebimentoApi from './Services/RecebimentoApi'

export default {
  RecebimentoApi,
}
